export function createJoinUsRoute(options: {
  path: string
  name: string
  metaName?: string
  pageCode?: string
  noPc?: boolean
  component?: any
}) {
  const { path, name, metaName, pageCode, noPc = false, component } = options

  const route: any = {
    path,
    name,
  }

  if (metaName || pageCode || noPc) {
    route.meta = {
      ...(metaName ? { name: metaName } : {}),
      ...(pageCode ? { pageCode } : {}),
      ...(noPc ? { noPc: true } : {}),
    }
  }

  if (component) {
    route.component = component
  }

  return route
}
